import { Component, Injector } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { BaseComponent } from 'src/app/common/base/base.component';
import { RegisterComponent } from 'src/app/common/extensions/decorator';
import { ProcedureReportService } from '../../services/procedure-report.service';

@RegisterComponent('TestManagerProcedureReportsComponent')
@Component({
  selector: 'app-test-manager-procedure-reports',
  templateUrl: './test-manager-procedure-reports.component.html',
  styleUrls: ['./test-manager-procedure-reports.component.scss']
})
export class TestManagerProcedureReportsComponent extends BaseComponent {

  loading = false;

  constructor(
    protected override injector: Injector,
    private procedureReportService: ProcedureReportService,
    private dialogRef: MatDialogRef<TestManagerProcedureReportsComponent>
  ) {
    super(injector);
  }

  /**
   * Invokes the manager-report PATCH endpoint and closes the dialog after a successful request.
   */
  generateReports() {
    this.loading = true;
    this.procedureReportService.generateManagersEmails().pipe(
      finalize(() => this.loading = false)
    ).subscribe({
      next: () => {
        this.alert.success('Manager procedure reports were generated.');
        this.dialogRef.close(true);
      },
      error: () => this.alert.defaultError()
    });
  }

  /** Closes the report test dialog without starting the email job. */
  cancel() {
    this.dialogRef.close();
  }
}
